module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 12.4c0-1.934-1.234-3.4-3-3.4-.724 0-1.996.687-3.662 2.187L16 12.39l-1.338-1.204C12.996 9.687 11.724 9 11 9c-1.766 0-3 1.466-3 3.4 0 2.303 2.62 5.76 8 10.062 5.38-4.303 8-7.759 8-10.062zM16 25C9.333 19.9 6 15.7 6 12.4 6 9.7 7.818 7 11 7c1.333 0 3 .9 5 2.7C18 7.9 19.667 7 21 7c3.182 0 5 2.7 5 5.4 0 3.3-3.333 7.5-10 12.6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-heart-outlined.svg
// module id = 690
// module chunks = 0